"use client";
import store, { dispatch, persistor } from '@/redux/index';
import { setUser } from '@/redux/slices/user.slice';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { requestPermissionAndGetToken } from '../lib/firebase-client';

export default function ReduxProvider({ children }: { children: React.ReactNode }) {
   useEffect(() => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            console.log('Service Worker registrado con éxito:', registration);
          })
          .catch((err) => {
            console.log('Error al registrar el Service Worker:', err);
          });
      }

      requestPermissionAndGetToken()
      .then((res) => {
        dispatch(setUser({tokenFCM: res}));
      });
    }, []);

  return(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {children}
        </PersistGate>
    </Provider>
  )}